import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
// import { IntercomProvider } from 'react-use-intercom';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import history from 'utils/history';
import { LiveDataProvider } from 'context/liveData';
import Auth from 'auth0-react';

import { mixpanel } from 'utils/mixpanel';

import { MixpanelProvider } from 'react-mixpanel';

import { AUTH0_CONFIG } from 'utils/commonConstants';
import * as serviceWorker from './serviceWorker';
import App from './pages/App';
import './index.css';

const queryClient = new QueryClient();
queryClient.setQueryDefaults('cachedFiltersData', {
  staleTime: Infinity,
  cacheTime: Infinity,
});

const onRedirectCallback = (appState: AppState) => {
  history.replace((appState && appState.returnTo) || window.location.pathname);
};

ReactDOM.render(
  <React.StrictMode>
    <MixpanelProvider mixpanel={mixpanel}>
      {/* <IntercomProvider
        appId={process.env.REACT_APP_INTERCOM_APP_ID as string}
        autoBoot
      > */}
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Auth0Provider {...AUTH0_CONFIG}>
            <LiveDataProvider>
              <App />
              {/* React Query Devtools, uncomment import and JSX to load. */}
              <ReactQueryDevtools initialIsOpen={false} />
            </LiveDataProvider>
          </Auth0Provider>
        </BrowserRouter>
      </QueryClientProvider>
      {/* </IntercomProvider> */}
    </MixpanelProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

const { scheduleRenewal } = new Auth();
scheduleRenewal();
// on each reload starting schedule renewal cycle to keep user always logged in by refreshing token before expiry

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
